import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@3plearning/react-components';
import cloneDeep from 'lodash/cloneDeep';
import {
    STRENGTH_TAB,
    TOPICS_TABLE_CONFIG,
    ACTIVITIES_TABLE_CONFIG
} from '../strength-and-weaknesses-constants';
import StrengthWeaknessTab from '../../../../components/strength-weakness-tab/strength-weakness-tab';

/**
 * Displays Strengths & Weaknesses tabs and tables for topics & activities
 * Used by Class, Group & Student views for Activity Mastery
 */
class TopicActivityStrengthWeakness extends PureComponent {
    static propTypes = {
        strengths: PropTypes.shape({
            activities: PropTypes.array,
            topics: PropTypes.array
        }),
        weaknesses: PropTypes.shape({
            activities: PropTypes.array,
            topics: PropTypes.array
        })
    };

    constructor(props) {
        super(props);
        this.state = { currentTab: STRENGTH_TAB };
        this.i18n = window.i18n;
    }

    tabClicked = (tab) => {
        this.setState({ currentTab: tab });
    };

    getTableConfig = (configData) => {
        const config = cloneDeep(configData);
        const { cols } = config;
        cols.map((col) => {
            if (col.doTranslation && this.i18n) {
                col.name = this.i18n._(col.name);
            }
            return col;
        });
        return config;
    };

    render() {
        const { currentTab } = this.state;
        const { strengths, weaknesses } = this.props;
        const isStrengthTab = currentTab === STRENGTH_TAB;
        return (
            <StrengthWeaknessTab
                onTabClick={this.tabClicked}
                isStrengthTab={isStrengthTab}
            >
                <DataTable
                    config={this.getTableConfig(TOPICS_TABLE_CONFIG)}
                    data={isStrengthTab ? strengths.topics : weaknesses.topics}
                />
                <DataTable
                    config={this.getTableConfig(ACTIVITIES_TABLE_CONFIG)}
                    data={
                        isStrengthTab
                            ? strengths.activities
                            : weaknesses.activities
                    }
                />
            </StrengthWeaknessTab>
        );
    }
}

export default TopicActivityStrengthWeakness;



// WEBPACK FOOTER //
// ./containers/activity-mastery/common/topic-activity-strength-weakness/topic-activity-strength-weakness.js